import { Module } from "vuex";

export interface LandingState {
  title: string;
  subtitle: string;
  cta: string;
  description: string;
}

const landing: Module<LandingState, any> = {
  namespaced: true,

  state: {
    title: "Klam Freestyle Coaching",
    subtitle:
      "Learn about freestyle snowboarding in the park aswell as on the mountain",
    cta: "Book Your Session",
    description:
      "Personalized snowboard coaching focused on progression, safety, and style. Whether you're learning your first 180 or dialing in advanced tricks, we help you level up with confidence.",
  },

  mutations: {
    setTitle(state, title: string) {
      state.title = title;
    },
  },

  actions: {
    updateTitle({ commit }, title: string) {
      commit("setTitle", title);
    },
  },
};

export default landing;
